/**
 * ナウローディングなjs
 */

import { TweenMax, TimelineMax, Linear, Back, Power1, Power4, Quad, Expo } from 'gsap';
import Modernizr from 'modernizr';
import imagesLoaded from 'imagesLoaded';
imagesLoaded.makeJQueryPlugin($);

const preLoading = () => {
  let loadedCount = 0; // current number of images loaded
  let loadingProgress = 0; // timeline progress - starts at 0
  // elm
  const $preloader = $('#preloader');
  const $preloaderProgress = $('.preloader-progress');
  const $preloaderTxtPerc = $('.preloader-txt-perc');
  const $preloadTarget = $('[data-preload],img');
  const $cover = $('#cover');
  // init
  const imagesToLoad = $preloadTarget.length; // number of slides with .bcg container
  const progressTl = new TimelineMax({ paused: true, onUpdate: progressUpdate, onComplete: loadComplete });

  TweenMax.set(window, { scrollTo: { y: 0 } });
  TweenMax.fromTo($preloaderTxtPerc, 0.8, { opacity: 0, x: 20 }, { opacity: 1, x: 0, ease: Back.easeInOut });
  progressTl
    .to($preloaderProgress.find('span'), 0.3, { width: '100%', ease: Linear.easeNone });

  if ($preloadTarget.length) {
    $preloadTarget.imagesLoaded({
      background: true,
    }).progress((instance, image) => {
      loadProgress();
    });
  } else {
    loadComplete();
  }

  function loadProgress(imgLoad, image) {
    loadedCount += 1;
    loadingProgress = (loadedCount / imagesToLoad);
    TweenMax.to(progressTl, 0.7, { progress: loadingProgress, ease: Linear.easeNone });
  }

  function progressUpdate() {
    loadingProgress = Math.round(progressTl.progress() * 100);
    const perc = (`000${loadingProgress}`).slice(-3);
    $preloaderTxtPerc.html(`${perc}<small>%</small>`);
  }

  function loadComplete() {
    const preloaderOutTl = new TimelineMax();
    const bgOutTl = new TimelineMax();
    const tween = { autoAlpha: 0, force3D: Modernizr.csstransforms3d };
    const preserve3D = { transformPerspective: 1000, perspective: 1000, transformStyle: 'preserve-3d', perspectiveOrigin: '50% 50%' };
    // intro bg-image animation timeline
    bgOutTl
      .set($('.cover-bg-car'), preserve3D, '+=2')
      .from($('.cover-bg-car'), 5, $.extend({}, tween, { z: 300, ease: Power1.easeOut }));
    // intro animation timeline
    preloaderOutTl
      .set($('.cover-intro-mij'), $.extend({}, preserve3D, tween))
      .to($preloaderProgress, 0.3, $.extend({}, tween, { x: '100%', ease: Power1.easeOutIn }))
      .to($preloaderTxtPerc, 0.3, $.extend({}, tween, { x: -20, ease: Back.easeInOut }), 0.1)
      .set($('body'), { className: '-=is-loading' })
      .set($('.cover'), { className: '+=is-loaded' })
      .to($preloader, 0.7, $.extend({}, tween, { yPercent: 100, ease: Power4.easeInOut }))
      .set($preloader, { className: '+=is-hidden' })
      .set($('.cover-hd-logo'), preserve3D)
      .from($('.cover-intro-mij'), 4, $.extend({}, tween, { z: 2000, rotationY: 90, ease: Expo.easeOut }), '-=0.3')
      .to($('.cover-intro-mij'), 1.2, { z: 800, autoAlpha: 0, force3D: Modernizr.csstransforms3d, ease: Expo.easeIn }, '-=0.7')
      .from($('.cover-hd-logo'), 1.4, $.extend({}, tween, { z: 600, rotationY: 60, ease: Back.easeInOut }), '-=0.48')
      .from($('.cover-hd-txt-45manmai'), 0.8, $.extend({}, tween, { x: -200, ease: Back.easeOut }), '-=0.8')
      .from($('.cover-hd-txt-saikyou'), 0.8, $.extend({}, tween, { x: 200, ease: Back.easeInOut }), '-=0.8')
      .from($('.cover-hd-subtitle'), 0.8, $.extend({}, tween, { y: 20, rotationY: 30, ease: Quad.easeInOut }), '-=0.1')
      .from($('.cover-mij-txt'), 0.6, $.extend({}, tween, { y: 10, rotationY: -30, ease: Back.easeInOut }), '-=0.5')
      .staggerFrom($('.cover-arrow>*'), 0.6, $.extend({}, tween, { y: -20, autoAlpha: 0 }), 0.1, '-=0.5');
    return preloaderOutTl;
  }
};

export default preLoading;



// WEBPACK FOOTER //
// ./src/scripts/common/preloader.js